<template>
  <div class="pwmat-introduce-background">
    <div class="pwmat-introduce-banner">
      <div class="pwmat-introduce-container">
        <div class="pwmat-introduce-banner-title">Q-Flow</div>
      </div>

      <img class="pwmat-introduce-banner-img" src="../../assets/about/banner.png">
    </div>
    <div class="pwmat-introduce-container">
      <div class="pwmat-introduce-content">
        <div class="pwmat-introduce-content-info">
          <div
            class="product-markdown-content"
            v-html="markdownHtml"
            @click="onMarkdownClick"
          ></div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import qflowMd from '!!../../../loaders/md-loader.js!@/common/lang/zh/qflow.md'
import qflowMdEn from '!!../../../loaders/md-loader.js!@/common/lang/en/qflow.md'
import { parseMarkdown } from '@/utils/simpleMarkdown'
import qflowImg from '@/assets/produce/QFlow/qflow.png'

const qflowImages = {
  'qflow.png': qflowImg,
}

export default {
  name: 'PWMGUIIntroduce',
  computed: {
    markdownHtml() {
      const md = this.$i18n.locale === 'en' ? qflowMdEn : qflowMd
      return parseMarkdown(md, { images: qflowImages })
    }
  },
  methods: {
    onMarkdownClick(event) {
      const link = event.target.closest('a[data-internal-link="true"]')
      if (!link) return
      event.preventDefault()
      const href = link.getAttribute('href') || ''
      const routeMap = {
        '/gpu-download': 'GPUDownload',
        '/module-download': 'ModuleDownload',
        '/potential-download': 'PotentialDownload',
      }
      const routeName = routeMap[href]
      if (routeName) {
        this.$router.push({ name: routeName })
      } else {
        this.$router.push(href)
      }
    }
  }
}
</script>

<style scoped>
.pwmat-introduce-container {
  width: 100%;
  padding-right: 15px;
  padding-left: 15px;
  margin-right: auto;
  margin-left: auto;
}
.pwmat-introduce-background {
  margin-top: 70px;
}
.pwmat-introduce-banner {
  overflow: hidden;
}
.pwmat-introduce-banner-title {
  font-size: 24px;
  font-family: PingFangSC-Semibold, sans-serif;
  font-weight: 600;
  color: rgba(255, 255, 255, 1);
  line-height: 50px;
  position: absolute;
  margin-top: 60px;
}
.pwmat-introduce-banner-img {
  min-width: 100%;
  height: 165px;
}
.pwmat-introduce-content {
  margin-top: 30px;
  margin-bottom: 90px;
}
.pwmat-introduce-content-info {
  margin-top: 40px;
}
.product-markdown-content {
  font-size: 16px;
  font-family: PingFangSC-Regular, sans-serif;
  font-weight: 400;
  color: rgba(79, 76, 77, 1);
  line-height: 25px;
}
.product-markdown-content >>> h2 {
  margin-top: 40px;
  margin-bottom: 16px;
  font-size: 24px;
  font-family: PingFangSC-Medium, sans-serif;
  font-weight: 500;
  color: rgba(73, 145, 201, 1);
  line-height: 36px;
}
.product-markdown-content >>> h3 {
  margin-top: 20px;
  margin-bottom: 16px;
  font-size: 30px;
  font-family: PingFangSC-Medium, sans-serif;
  font-weight: 500;
  color: rgba(73, 145, 201, 1);
  line-height: 50px;
  text-align: center;
}
.product-markdown-content >>> h4 {
  margin-top: 24px;
  margin-bottom: 12px;
  font-size: 18px;
  font-family: PingFangSC-Semibold, sans-serif;
  font-weight: 600;
  color: rgba(73, 145, 201, 1);
  line-height: 28px;
}
.product-markdown-content >>> p {
  margin-bottom: 16px;
}
.product-markdown-content >>> a {
  color: rgba(73, 145, 201, 1);
  text-decoration: none;
  cursor: pointer;
  margin-right: 16px;
}
.product-markdown-content >>> a:hover {
  text-decoration: underline;
}
.product-markdown-content >>> .md-image-row {
  display: flex;
  justify-content: center;
  align-items: center;
  gap: 16px;
  margin: 24px 0;
}
.product-markdown-content >>> .md-image {
  display: block;
  max-width: 100%;
  height: auto;
  margin: 24px auto;
}
.product-markdown-content >>> .md-image-row .md-image {
  margin: 0;
}
.product-markdown-content >>> ol {
  padding-left: 20px;
  margin-bottom: 16px;
}
.product-markdown-content >>> li {
  margin-bottom: 8px;
}
@media screen and (max-width: 482px) {
  .pwmat-introduce-container {
    max-width: 100%;
  }
}
@media screen and (min-width: 482px) and (max-width: 768px) {
  .pwmat-introduce-container {
    max-width: 450px;
  }
}
@media screen and (min-width: 768px) and (max-width: 1100px) {
  .pwmat-introduce-container {
    max-width: 736px;
  }
}
@media screen and (min-width: 1100px) and (max-width: 1444px) {
  .pwmat-introduce-container {
    max-width: 1068px;
  }
}
@media screen and (min-width: 1444px) {
  .pwmat-introduce-container {
    max-width: 1068px;
  }
}
</style>
